import React from 'react';
import { useTranslation } from 'react-i18next';

const CreatorsPagination = ({ currentPage, totalPages, totalCount, pageSize, onPageChange }) => {
  const { t } = useTranslation();
  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    const delta = 2;
    const left = Math.max(1, currentPage - delta);
    const right = Math.min(totalPages, currentPage + delta);

    if (left > 1) {
      pages?.push(1);
      if (left > 2) pages?.push('...');
    }
    for (let i = left; i <= right; i++) pages?.push(i);
    if (right < totalPages) {
      if (right < totalPages - 1) pages?.push('...');
      pages?.push(totalPages);
    }
    return pages;
  };

  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalCount);

  return (
    <div className="flex items-center justify-between mt-4">
      <p className="text-xs" style={{ color: 'rgba(255,255,255,0.35)', fontFamily: 'Inter, sans-serif' }}>
        {t('admin.creators.paginationInfo', '{{start}}–{{end}} sur {{total}} créateurs', { start: startItem, end: endItem, total: totalCount })}
      </p>
      <div className="flex items-center gap-1">
        {/* Previous */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1.5 rounded text-xs font-medium transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
          style={{
            backgroundColor: '#111111',
            border: '1px solid #1f1f1f',
            color: 'rgba(255,255,255,0.6)',
            fontFamily: 'Inter, sans-serif',
          }}
          onMouseEnter={(e) => { if (currentPage !== 1) e.currentTarget.style.borderColor = 'var(--color-primary)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#1f1f1f'; }}
        >
          ← {t('admin.creators.previous', 'Précédent')}
        </button>

        {/* Page numbers */}
        {getPageNumbers()?.map((page, idx) => (
          page === '...' ? (
            <span key={`ellipsis-${idx}`} className="px-2 py-1.5 text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>...</span>
          ) : (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className="w-8 h-8 rounded text-xs font-medium transition-colors"
              style={{
                backgroundColor: currentPage === page ? '#E5202A' : '#111111',
                border: `1px solid ${currentPage === page ? '#E5202A' : '#1f1f1f'}`,
                color: currentPage === page ? 'white' : 'rgba(255,255,255,0.6)',
                fontFamily: 'Sora, sans-serif',
              }}
            >
              {page}
            </button>
          )
        ))}

        {/* Next */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-1.5 rounded text-xs font-medium transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
          style={{
            backgroundColor: '#111111',
            border: '1px solid #1f1f1f',
            color: 'rgba(255,255,255,0.6)',
            fontFamily: 'Inter, sans-serif',
          }}
          onMouseEnter={(e) => { if (currentPage !== totalPages) e.currentTarget.style.borderColor = 'var(--color-primary)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#1f1f1f'; }}
        >
          {t('admin.creators.next', 'Suivant')} →
        </button>
      </div>
    </div>
  );
};

export default CreatorsPagination;
